export default "<p>coupon works!</p>\n";